import { render } from "./LiveSummary.vue?vue&type=template&id=15a676e5&scoped=true"
import script from "./LiveSummary.vue?vue&type=script&lang=ts"
export * from "./LiveSummary.vue?vue&type=script&lang=ts"

import "./LiveSummary.vue?vue&type=style&index=0&id=15a676e5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15a676e5"

export default script